import { VNLOADER_SET_SPINNER } from './ActionTypes'

export const setSpinner = (show, text = '') => ({
  type: VNLOADER_SET_SPINNER,
  payload: { show, text },
})

export const stopSpinner = () => setSpinner(false)
